export default __webpack_public_path__ + "static/media/scan-book-blue.40c766d6.svg";